import CollectionPageMultiSelectPage from "@faire/prototype-playground/workspace/nh/collection-multiselect";
import FormPage from "@faire/prototype-playground/workspace/nh/form";
import MarketingModalTitleSizeAuditPage from "@faire/prototype-playground/workspace/nh/marketing-modal-title-size-audit";
import ModalWidthAuditPage from "@faire/prototype-playground/workspace/nh/modal-width-audit";
import NestedRadioBlockIterationsPage from "@faire/prototype-playground/workspace/nh/nested-radio-block-iterations";
import ProgressiveModalPage from "@faire/prototype-playground/workspace/nh/progressive-modal";
import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import PasswordStrengthMeterPage from "../../workspace/nick/password-strength-meter";

const FileUploadPage = lazy(() => import("../../pages/FileUploadPage"));
const QuantityPickerPage = lazy(() => import("../../pages/QuantityPickerPage"));

export const slug = "nh";

export function NickHowlandRoutes() {
  return (
    <Switch>
      <Route
        path="/nh/collection-multiselect"
        component={CollectionPageMultiSelectPage}
      />
      <Route path="/nh/file-upload" component={FileUploadPage} />
      <Route path="/nh/form" component={FormPage} />
      <Route
        path="/nh/marketing-modal-title-size-audit"
        component={MarketingModalTitleSizeAuditPage}
      />
      <Route path="/nh/modal-width-audit" component={ModalWidthAuditPage} />
      <Route
        path="/nh/nested-radio-block-iterations"
        component={NestedRadioBlockIterationsPage}
      />
      <Route
        path="/nh/password-strength-meter"
        component={PasswordStrengthMeterPage}
      />
      <Route path="/nh/progressive-modal" component={ProgressiveModalPage} />
      <Route path="/nh/quantity-picker" component={QuantityPickerPage} />
    </Switch>
  );
}
